import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faPlus, faUpload, faBan } from '@fortawesome/free-solid-svg-icons';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ApiServicesService } from '../services/api-services.service';
import { SnackbarService } from '../services/snackbar.service';
import { UserDetailsService } from '../services/user-details.service';

@Component({
  selector: 'app-upload-photos',
  standalone: true,
  imports: [FontAwesomeModule, CommonModule, MatProgressSpinnerModule],
  templateUrl: './upload-photos.component.html',
  styleUrl: './upload-photos.component.css'
})

export class UploadPhotosComponent {
  faplus = faPlus
  faUpload = faUpload
  faBan = faBan
  imagePreviews: { url: string, binaryData: File }[] = [];
  baseUrl: string = 'http://localhost:4200';
  formateErrror: boolean = false;
  fileLimitError: boolean = false;
  album_id: any = '';

  @Input() public set albumId(value: any) {
    if (value !== '' && value !== null && value !== undefined) {
      this.album_id = value;
    } else {
      this.album_id = '';
    }
  }

  constructor(public api: ApiServicesService, private snackbarService: SnackbarService, private userdetails: UserDetailsService) { }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.processFiles(input.files);
    }
    input.value = '';
  }


  removeImg(index: number): void {
    this.imagePreviews.splice(index, 1);
  }

  removeAll() {
    this.imagePreviews = [];
    this.formateErrror = false;
  }

  showText: boolean = true;

  uploadFiles() {
    const formData = new FormData();
    this.imagePreviews.forEach((preview) => {
      formData.append(`photo`, preview.binaryData, preview.binaryData.name);
    });
    if (this.album_id) {
      formData.append('albumId', this.album_id);
    }
    this.showText = false;
    this.api.uploadPhotos(formData).subscribe({
      next: (response) => {
        this.showText = true;
        this.imagePreviews = []
        this.userdetails.refreshPhotos.next(true);
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            message: response.message,
            className: 'success',
          }
        );
      },
      error: (err) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    })
  }

  isDragging: boolean = false;

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;

    if (event.dataTransfer && event.dataTransfer.files) {
      this.processFiles(event.dataTransfer.files);
    }
  }

  private processFiles(fileList: FileList): void {
    const allowedTypes = /^image\//;
    const maxFiles = 5;
    this.fileLimitError = false;
    this.formateErrror = false;

    const files = Array.from(fileList);
    const remainingSlots = maxFiles - this.imagePreviews.length;

    if (files.length > remainingSlots) {
      this.fileLimitError = true;
    }

    files.slice(0, remainingSlots).forEach((file) => {
      if (allowedTypes.test(file.type)) {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result) {
            this.imagePreviews.push({ url: reader.result as string, binaryData: file });
          }
        };
        reader.readAsDataURL(file);
      } else {
        this.formateErrror = true;
      }
    });
  }
}
